<div class="modal">
  <div class="modalOverlay"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <h5 class="modalContentTitle">
        利用登録を完了させてください
      </h5>
      <p>
        予約に必要な項目が登録されていません。プロフィールを入力して利用登録を行う必要があります。
      </p>
    </div>
    <div class="modalControl">
      <a (click)="onClickNoPrifleAlert()">OK</a>
    </div>
  </div>
</div>
